<template>
  <div class="merge-investigation">
    <loader v-if="loading"/>
    <div class="close-button-container">
      <img class="close-button" :class="{ 'disabled': loading }" :src="require('@/assets/icons/ic-close.svg')" v-on:click="closeModal">
    </div>
    <div class="cards-container">
      <template v-for="papaQuestion in papasMergeQuestions">
        <papas-merge-card v-if="!papaQuestion.input"
                          class="open-card"
                          :key="papaQuestion.transactionId"
                          :question="papaQuestion"/>
        <papas-merge-closed-card v-else
                                 :question="papaQuestion"
                                 :key="papaQuestion.transactionId"/>
      </template>
      <template v-for="sonsQuestion in sonsMergeQuestions">
        <sons-merge-card v-if="!sonsQuestion.input"
                         class="open-card"
                         :key="sonsQuestion.chunkId"
                         :question="sonsQuestion"/>
        <sons-merge-closed-card v-else
                                :question="sonsQuestion"
                                :key="sonsQuestion.chunkId"/>
      </template>
    </div>
    <riseup-button class="done-btn"
                   :disabled="!allQuestionsAnswered"
                   :action="() => doneAnswering()"
                   :title="'סיימתי לענות!'"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '../../../../../../../Segment';
import PapasMergeCard from './PapasMergeCard.vue';
import PapasMergeClosedCard from './PapasMergeClosedCard.vue';
import SonsMergeCard from './SonsMergeCard.vue';
import SonsMergeClosedCard from './SonsMergeClosedCard.vue';
import router from '../../../../../../../router';
import Loader from '../../../../../../../base-components/Loader.vue';

export default {
  name: 'MergeInvestigation',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Loader,
    PapasMergeCard,
    PapasMergeClosedCard,
    SonsMergeCard,
    SonsMergeClosedCard,
  },
  created() {
    Segment.trackUserGot('MergeInvestigatorEntered');
  },
  props: {
    onDoneInvestigation: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('mergeInvestigationQuestions', [
      'allQuestionsAnswered',
    ]),
    ...mapState('mergeInvestigationQuestions', [
      'papasMergeQuestions',
      'sonsMergeQuestions',
      'loading',
    ]),
  },
  methods: {
    ...mapActions('mergeInvestigationQuestions', ['finishMergeInvestigation']),
    async closeModal() {
      if (!this.loading) {
        this.$emit('close');
      }
    },
    async doneAnswering() {
      const createdNewCreds = await this.finishMergeInvestigation();
      this.onDoneInvestigation();
      this.closeModal();
      if (createdNewCreds) {
        router.push({ path: '/credentials' });
      }
      Segment.trackUserGot('MergeInvestigationDoneAnswering');
    },
  },
};
</script>

<style lang="scss" scoped>
  .merge-investigation {
    text-align: right;
    margin: 16px;

    .close-button-container {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .close-button {
        cursor: pointer;

        &.disabled {
          cursor: default;
        }
      }
    }

    .cards-container {
      .open-card {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
    .done-btn {
      margin-top: 32px;
      width: 100%;
    }
  }
</style>
